<script lang="ts">
  import Phone from "../../assets/icons/user/phone.svg";
  import User from "../../assets/icons/user/user.svg";
  import { getCopy } from "../../lib/stores/copy";
  import BaseCard from "../Card/BaseCard.svelte";
  import Typography from "../Typography.svelte";
  import { TypographyType } from "../../lib/constants/typographyMap";
  import { getMaskedPhone } from "../../lib/helpers/userDetails";
  import CardItem from "../Card/CardItem.svelte";
  import PATHS from "../../lib/constants/routePaths";
  import { navigateToPath } from "../../lib/routing";
  import Ticked from "../../assets/icons/circle-tick.svg";
  import Calendar from "../../assets/icons/calendar.svg";
  import TextIcon from "../../assets/icons/text.svg";
  import Unticked from "../../assets/icons/circle-minus.svg";
  import { userStore } from "../../lib/stores/user";
  import { settingsStore } from "../../lib/stores/settings";
  export let hideEditButton: boolean = false;
  export let onCardEditCallback: () => Promise<void> = async () => {};

  const onEditClick = () => {
    void (async () => {
      await onCardEditCallback();
      navigateToPath(PATHS.USER_DETAILS);
    })();
  };

  $: userName = `${$userStore.user?.first_name} ${$userStore.user?.last_name}`;
  $: maskedPhone = getMaskedPhone($userStore.user?.phone);
  $: copy = $getCopy("user") as Record<string, string>;
  $: reviewCopy = $getCopy("review") as Record<string, string>;
  $: configuredCustomFields = $settingsStore.custom_fields ?? [];
  $: customFieldInfo = configuredCustomFields.map(({ name, identifier, type }) => ({
    description: copy[`customField-${identifier}Copy`] ?? name,
    value: $userStore.customFields[name],
    type
  }));
</script>

<BaseCard headerCopy={reviewCopy.userCardHeaderCopy} {onEditClick} {hideEditButton}>
  <svelte:fragment slot="card items">
    <div class="flex items-center gap-3 self-center w-full">
      <img src={User} alt={userName} class="w-6 h-6" />
      <div class="flex flex-col">
        <Typography mobile={TypographyType.Body1Medium} desktop={TypographyType.Headline5Medium}>
          {userName}
        </Typography>
        <Typography
          mobile={TypographyType.Body2Regular}
          desktop={TypographyType.Body2Medium}
          copy={$userStore.user?.email}
          --font-color="var(--color-grayscale-90)" />
      </div>
    </div>
    {#if !copy.disablePhone}
      <CardItem value={maskedPhone} icon={Phone} />
    {/if}
    {#each customFieldInfo as { description, value, type }}
      {#if type === "text_input"}
        <CardItem value={`${description}: ${value}`} icon={value ? TextIcon : Unticked} />
      {:else if type === "date_input"}
        <CardItem value={`${description}: ${value}`} icon={value ? Calendar : Unticked} />
      {:else}
        <CardItem value={description} icon={value ? Ticked : Unticked} />
      {/if}
    {/each}
  </svelte:fragment>
</BaseCard>
